import React from 'react'
import { HardwareGrid } from '../../../metrics_server/hardware/components/HardwareGrid/HardwareGrid'
import { deviceTypes } from '../../../metrics_server/hardware/data_types'

export const BallSetup = () => {
  return (
    <HardwareGrid
      deviceTypeValue={deviceTypes.items.ball.value}
      isSessionAssignment={true}
    />
  )
}
